<template>
    <div id="lx-online-booking-checkout-complete-booking" class="lx-online-booking-checkout-complete-booking">
        <div class="lx-online-booking-checkout-complete-booking__due">
            <div>
                <div>Amount Due</div>
                <div v-if="!!client.guest_credit_amount">(will be addressed post booking by the property manager)</div>
                <div v-else>(due immediately)</div>
            </div>
            <div class="lx-online-booking-checkout-complete-booking__due__amount">
                {{ !!client.guest_credit_amount ? guestCreditBalance : scheduleDepositSumAmount }}
            </div>
        </div>
        <div v-if="!client.guest_credit_amount" class="lx-online-booking-checkout-complete-booking__due-extra">
            <div
                v-if="
                    reservation.schedule.other_deposit.sum > 0 &&
                    (reservation.schedule.deposit_at_time_of_reservation || reservation.schedule.balance.sum == 0)
                "
            >
                ** Payment amount includes a security deposit of
                {{ scheduleOtherDepositSumAmount }}
            </div>
            <div v-if="reservation.schedule.balance.sum > 0 && reservation.schedule.balance.on_arrival">
                ** Remaining balance is due on arrival.
            </div>
            <div v-if="reservation.schedule.balance.sum > 0 && !reservation.schedule.balance.on_arrival">
                ** Remaining balance is due
                {{ reservation.schedule.balance.days_before_arrival }}
                days before arrival.
            </div>
        </div>
        <hr />
        <div>
            <button-book
                :disabled="invalid || !isRentalAgreementValid || busy || rentalAgreementBusy || hasHostedFormErrors"
                :variant="buttonVariant"
            />
        </div>
        <div
            class="lx-online-booking-checkout-complete-booking__required-fields"
            v-if="invalidRequiredFields.length !== 0 || isNotSigned"
        >
            <b-alert show variant="danger" class="lx-online-booking-checkout-complete-booking__required-fields__alert">
                <b class="mb-1">The following fields are required:</b>
                <ul class="lx-online-booking-checkout-complete-booking__required-fields__alert__list">
                    <li v-for="field in invalidRequiredFields" :key="field.id">
                        {{ field.name }}
                    </li>
                    <li v-if="isNotSigned && !isSignAgain">Accept the Rental Agreement</li>
                    <li v-if="isNotSigned && isSignAgain">Rental Agreement has been updated, please re-sign</li>
                </ul>
            </b-alert>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { toAmountDisplay } from '../../../../utils/numbers';
    import { calculateTotal } from '../common/utils';
    import ButtonBook from './button-book.vue';

    export default {
        name: 'OnlineBookingCheckoutCompleteBooking',
        components: {
            ButtonBook,
        },
        props: {
            invalid: {
                type: Boolean,
                default: false,
            },
            fields: {
                type: Object,
                default: () => ({}),
            },
            buttonVariant: {
                type: String,
                default: 'light',
            },
        },
        computed: {
            ...mapGetters('onlineBooking', [
                'busy',
                'client',
                'reservation',
                'rentalAgreementBusy',
                'rentalAgreement',
                'isSignAgain',
            ]),
            guestCreditBalance() {
                const total = calculateTotal({
                    reservation: this.reservation,
                    client: this.client,
                });
                return toAmountDisplay({
                    amount: total,
                    currency: this.reservation.currency.symbol,
                });
            },
            scheduleDepositSumAmount() {
                return toAmountDisplay({
                    amount: this.reservation.schedule.deposit.sum,
                    currency: this.reservation.currency.symbol,
                });
            },
            scheduleOtherDepositSumAmount() {
                return toAmountDisplay({
                    amount: this.reservation.schedule.other_deposit.sum,
                    currency: this.reservation.currency.symbol,
                });
            },
            isRentalAgreementValid() {
                if (this.rentalAgreement) {
                    return this.client.is_signed;
                }
                return true;
            },
            isNotSigned() {
                return this.rentalAgreement && !this.client.is_signed;
            },
            hasHostedFormErrors() {
                return this.client.invoice_variables_form_errors?.length > 0;
            },
            invalidRequiredFields() {
                const hostedFormErrors = this.client.invoice_variables_form_errors || [];
                return [
                    ...Object.values(this.fields).filter((field) => {
                        return field.required && field.invalid;
                    }),
                    ...hostedFormErrors,
                ];
            },
        },
        watch: {
            selectedGridProperties(properties) {
                this.refresh();
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    #lx-online-booking-checkout-complete-booking .lx-online-booking-checkout-complete-booking {
        &__due {
            display: flex;
            justify-content: space-between;
            align-items: center;

            &__amount {
                font-size: 30px;
                font-weight: bold;
            }
        }

        &__due-extra {
            margin-top: 0.5rem;
            font-size: 13px;
        }

        &__required-fields {
            margin-top: 1rem;
            font-size: 13px;

            &__alert {
                padding: 1rem;

                &__list {
                    margin: 0;
                }
            }
        }
    }
</style>
